import { Component, OnInit, Input } from '@angular/core';
import { EcommerceGenericoService, HistorialPedidos, OrderSituacion } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'estados-traking-mmax',
  templateUrl: './estados-traking-mmax.component.html',
  styleUrls: ['./estados-traking-mmax.component.scss']
})

export class EstadosTrakingMmaxComponent implements OnInit {
  @Input() myEstado: string;

  iconreference: string;
  estados: EstadoView[] = [];
  pedido: any;
  estado: string;
  pagoDiferido: string;

  constructor(private genServ : EcommerceGenericoService) {
    this.iconreference = '../../assets/icons/checkpedidos.svg';
    this.genServ.getPagoDiferido().subscribe(data => {
      this.pagoDiferido = (data || '').toString().trim();
      this.reconstruirEstados();
    });
  }

  ngOnInit(): void {
    this.pedido = this.genServ.getDetalleElegido();
    this.estado = this.genServ.getStatusDisplay(this.pedido);
    
    this.myEstado = this.myEstado || '';
    this.reconstruirEstados();
  }

  reconstruirEstados() {
    this.estados = [
      { nombre: OrderSituacion.ESPERA_PAGO, activado: false },
    ];

    // Dependiendo de si es pago diferido o no, mostramos un estado u otro
    if (this.pagoDiferido === 'S' || this.pagoDiferido === 'E') {
      this.estados.push({ nombre: OrderSituacion.PAGO_DIFERIDO, activado: false });
    } else {
      this.estados.push({ nombre: OrderSituacion.PAGADO, activado: false });
    }

    this.estados.push({ nombre: OrderSituacion.PREPARACION, activado: false });
    this.estados.push({ nombre: OrderSituacion.ESPERA_ENTREGA, activado: false });
    this.estados.push({ nombre: OrderSituacion.ENTREGADO, activado: false });

    this.marcarEstadoActual();
  }

  marcarEstadoActual() {
    if (!this.estados || this.estados.length === 0 || !this.estado) return;

    console.log('DEBUG: EstadosTrakingMmaxComponent -> marcando estado:', this.estado);
    const estadoNormalizado = this.estado.toLowerCase().trim();

    let indiceEncontrado = -1;
    for (let i = 0; i < this.estados.length; i++) {
        const nombreEstado = this.estados[i].nombre.toLowerCase().trim();
        
        // Lógica de coincidencia robusta
        if (nombreEstado === estadoNormalizado || 
            nombreEstado.includes(estadoNormalizado) || 
            estadoNormalizado.includes(nombreEstado)) {
          indiceEncontrado = i;
          break;
        }
    }

    // Caso especial: "En preparación" marca también los anteriores
    if (estadoNormalizado === OrderSituacion.PREPARACION.toLowerCase()) {
       this.estados[0].activado = true;
       this.estados[1].activado = true;
       this.estados[2].activado = true;
       return;
    }

    console.log('DEBUG: EstadosTrakingMmaxComponent -> indiceEncontrado:', indiceEncontrado);

    if (indiceEncontrado !== -1) {
      for (let i = 0; i <= indiceEncontrado; i++) {
        this.estados[i].activado = true;
      }
    }
  }
}

interface EstadoView {
  nombre: string,
  activado: boolean
}
